import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { Card, CardBody } from "reactstrap";
import { useDispatch } from "react-redux";
import AirHomeLoader from "../../../../components/Common/AirHomeLoader";
import Request from "../../../../helpers/request";
import { RefreshBtn } from "../../../../components/Common/button";
import Select from "react-select";

const MonthOptions = [
  { label: "January", value: 1 },
  { label: "February", value: 2 },
  { label: "March", value: 3 },
  { label: "April", value: 4 },
  { label: "May", value: 5 },
  { label: "June", value: 6 },
  { label: "July", value: 7 },
  { label: "August", value: 8 },
  { label: "September", value: 9 },
  { label: "October", value: 10 },
  { label: "November", value: 11 },
  { label: "December", value: 12 },
];

const currentYear = new Date().getFullYear(); // 2026
const startYear = 2014;

const YearOptions = Array.from(
  { length: currentYear - startYear + 1 },
  (_, i) => {
    const year = currentYear - i; // Start from the top and go down
    return { label: year, value: year };
  }
);

interface InterfaceDataTable {
  apiURL: string;
  title?: string;
  isReload?: boolean;
  columns: any[];
  loading: boolean;
  setLoading: (loading: boolean) => void;
  userId: any;
}

function SessionDataTable({
  userId,
  apiURL,
  title,
  isReload,
  columns,
  loading,
  setLoading,
}: InterfaceDataTable) {
  const [data, setData] = useState<any[]>([]);

  const [totalRows, setTotalRows] = useState<number>(0);
  const [page, setPage] = useState<number>(1);

  const handlePageChange = (newPage: number) => setPage(newPage);
  const [perPage, setPerPage] = useState<number>(10);
  const [searchText, setSearchText] = useState<string>("");
  const [month, setMonth] = useState<any>(null);
  const [year, setYear] = useState<any>(null);

  const fetchData = async (
    page: number,
    perPage: number,
    searchValue: string
  ) => {
    setLoading(true);
    try {
      const reqObj = {
        draw: 1,
        order: [],
        start: (page - 1) * perPage,
        length: perPage,
        search: {
          value: searchValue,
          regex: false,
        },
        userId: userId,
        ...(month ? { month: month.value } : {}),
        ...(year ? { year: year.value } : {}),
      };

      const response = await Request.post(apiURL, reqObj);

      setData(response.data.data || []);
      setTotalRows(response.data.recordsTotal || 0);
    } catch (error: any) {
      console.error("Error fetching data:", error);
      if (error.response && error.response.status === 401) {
        // window.localStorage.clear();
        // localStorage.removeItem("userInfo");
        // localStorage.removeItem("selectedPremiseID");
        // localStorage.removeItem("selectedUserID");
        // localStorage.removeItem("selectedUserEmail");
        // localStorage.removeItem("Authorization");
        // localStorage.removeItem("permissions");
        // window.location.reload();
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(page, perPage, searchText);
  }, [page, perPage, searchText, apiURL, isReload, month, year]);

  const handlePerRowsChange = (newPerPage: number, newPage: number) => {
    setPerPage(newPerPage);
    setPage(newPage);
  };

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchText(e.target.value);
    setPage(1);
  };
  const handleReload = () => {
    fetchData(page, perPage, searchText);
  };

  function handleMonths(value: any) {
    setMonth(value);
  }

  function handleYear(value: any) {
    setYear(value);
  }

  const Styles = {
    control: (provided: any, state: any) => ({
      ...provided,
      minHeight: 28, // ✅ small height
      height: 28,
      fontSize: "10px", // ✅ small text
      boxShadow: "none",
    }),

    indicatorsContainer: (provided: any) => ({
      ...provided,
      height: 28,
    }),

    menu: (provided: any) => ({
      ...provided,
      backgroundColor: "white",
      boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
      fontWeight: "normal",
      zIndex: 9999,
    }),

    placeholder: (provided: any) => ({
      ...provided,
      color: "#6c757d",
      fontWeight: "normal",
      fontSize: "13px",
    }),

    singleValue: (provided: any) => ({
      ...provided,
      color: "#333",
      fontWeight: "normal",
      fontSize: "14px",
    }),
  };

  return (
    <Card>
      <CardBody>
        <div className="">
          <DataTable
            columns={columns}
            data={data}
            pagination
            paginationServer
            paginationTotalRows={totalRows}
            onChangePage={handlePageChange}
            onChangeRowsPerPage={handlePerRowsChange}
            highlightOnHover
            customStyles={customStyles}
            paginationRowsPerPageOptions={[10, 25, 50, 100]}
            subHeader
            subHeaderComponent={
              <div className="container-fluid p-0 pb-2">
                <div className="row gx-2 gy-2 align-items-center">
                  <div className="col-12 col-md-6 d-flex flex-wrap align-items-center gap-2">
                    <h5 className="m-0 fw-bold" style={{ fontSize: "18px" }}>
                      {title || "Data Table"}
                    </h5>
                  </div>

                  {/* Search and Action Buttons */}
                  <div className="col-12 col-md-6 d-flex flex-wrap justify-content-md-end align-items-center gap-2">
                    {/* month and year */}

                    <div className="d-flex gap-2 ">
                      <div style={{}}>
                        <Select
                          value={month}
                          onChange={handleMonths}
                          options={MonthOptions}
                          className="select2-selection"
                          id="customFilterInput"
                          styles={Styles}
                          placeholder="Select Month"
                        />
                      </div>

                      <div style={{}}>
                        <Select
                          value={year}
                          onChange={handleYear}
                          options={YearOptions}
                          className="select2-selection"
                          id="customFilterInput"
                          styles={Styles}
                          placeholder="Select Year"
                        />
                      </div>
                    </div>

                    {/* Search Input */}

                    <input
                      type="text"
                      placeholder="Search..."
                      className="form-control form-control-sm"
                      style={{ maxWidth: "150px" }}
                      value={searchText}
                      onChange={handleSearch}
                    />

                    <RefreshBtn onClick={handleReload} loading={loading} />
                  </div>
                </div>
              </div>
            }
          />
        </div>
        {loading && <AirHomeLoader />}
      </CardBody>
    </Card>
  );
}

export default SessionDataTable;

export const customStyles: any = {
  tableWrapper: {
    style: {
      minWidth: "1100px",
    },
  },
  subHeader: {
    style: {
      padding: "0px",
      margin: "0px",
    },
  },
  headRow: {
    style: {
      backgroundColor: "#EFF2F7",
      fontWeight: "bold",
      fontSize: "14px",
      borderBottom: "none",
    },
  },
  rows: {
    style: {
      fontSize: "14px",
      color: "#343a40",
      borderBottom: "none",
    },
  },
  cells: {
    style: {
      fontSize: "14px",
      color: "#343a40",
      borderBottom: "none",
    },
  },
};
